<template>
  <v-card flat width="175" @click="selectSubCategory">
    <v-card-title>
      <v-avatar size="100" class="mx-auto">
        <v-img position="center center" :src="subCategory.imageThumbUrl || require('@/assets/imgnotfound.jpg')"
          width="100" height="100" aspect-ratio="1" contain />
      </v-avatar>
    </v-card-title>
    <v-card-subtitle class="text-subtitle-2 text-center truncate-subtitle">
      {{ subCategory.name }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: "SubCategoryCard",
  props: {
    subCategory: Object,
  },
  methods: {
    selectSubCategory() {
      this.$emit("select", this.subCategory);
    },
  },
};
</script>

<style scoped>
.truncate-subtitle {
  /* Set height for 3 lines and enable truncation */
  height: 4.2em;
  line-height: 1.4em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
</style> 